// extracted by mini-css-extract-plugin
export default {"container":"styles_container__SNI3z","wrapper":"styles_wrapper__5NUrR","title":"styles_title__oUxNS","button":"styles_button__IeH1s"};